import { breakpoints, matchBreakpoint } from "../common/utils";

(() => {
  const offset = 100;
  const documentBody = $("html, body");
  const scrollTrigger = $("[data-scroll-to]");
  const scrollContainers = $("[data-scroll-to-container]");
  const stickedNavigation = $(".c-product-navigation__to-stick");
  const stickedNavigationPosition = stickedNavigation.length
    ? stickedNavigation.offset().top
    : "";
  let containerList = {};
  const fillContainerList = () => {
    scrollContainers.each(function(element) {
      const that = $(this);
      const fromTop = that.offset().top;
      const height = that.outerHeight() + fromTop;
      const containerId = that.attr("data-scroll-to-container");

      containerList[element] = {
        id: containerId
      };
      containerList[element].top = fromTop;
      containerList[element].height = height;
    });
  };

  const makeNavigationSticked = scrollPosition => {
    const loggedInAdjustHeight = $("body").hasClass("logged-in") ? 32 : 0;
    const stickedHeaderHeight =
      $("[data-sticked-header]").outerHeight() + loggedInAdjustHeight;

    if (scrollPosition - 210 > stickedNavigationPosition) {
      if (!stickedNavigation.hasClass("sticked")) {
        stickedNavigation.addClass("sticked");
        stickedNavigation.css("top", stickedHeaderHeight);
      }
    } else {
      stickedNavigation.removeClass("sticked");
      stickedNavigation.css("top", 0);
    }
  };

  const scrollToContainer = event => {
    const that = $(event.target);
    const thatId = that.attr("data-scroll-to");
    const containerOffset =
      $("[data-scroll-to-container='" + thatId + "']").offset().top -
      offset -
      80;

    documentBody.animate(
      {
        scrollTop: containerOffset
      },
      1000
    );
  };

  const makeActiveOnScroll = event => {
    const currentScrollPosition = $(event.target).scrollTop() + 210;

    makeNavigationSticked(currentScrollPosition);

    if (Object.entries(containerList).length === 0) {
      return;
    }

    for (const key in containerList) {
      const id = containerList[key].id;
      const top = containerList[key].top - offset;
      const height = containerList[key].height;
      const activateElement = $("[data-scroll-to-container='" + id + "']");
      let activateNavElement = $("[data-scroll-to='" + id + "']");

      if (currentScrollPosition > top && currentScrollPosition < height) {
        if (
          activateElement
            .prev()
            .hasClass("project-details__category-title--subtitle")
        ) {
          activateNavElement = $(
            "[data-scroll-to='" +
              activateElement
                .prev()
                .prev()
                .data("scroll-to-container") +
              "']"
          );
          activateNavElement.addClass("active");
        }

        if (!activateElement.hasClass("active")) {
          activateElement.addClass("active");
          activateNavElement.addClass("active");
        }
      } else {
        activateElement.removeClass("active");
        activateNavElement.removeClass("active");
        if (window.scrollY < 150) {
          $(".sticky-nav__item:first-child .sticky-nav__link").addClass(
            "active"
          );
        }
      }
    }
  };

  fillContainerList();

  scrollTrigger.on("click", scrollToContainer);

  $(window).on("scroll", makeActiveOnScroll);
})();
